<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('classes'), classes('customClasses'))">
      <div :class="elementClasses(classes('containerClasses'))">
        <div
          class="wf-flex-1"
          :class="elementClasses(classes('contentClasses'))"
          :style="elementStyles(styles('styles'))"
        />
        <div
          v-if="content.hasText"
          class="wf-flex-none wf-inset-y-0 focus:wf-outline-none"
          :class="elementClasses(classes('textClasses'))"
          :style="elementStyles(styles('textStyles'))"
          contenteditable
          v-text="content.text"
          @input="updateContentProperty('text', $event.target.textContent)"
        />
        <div
          v-if="content.hasIcon"
          class="wf-w-10 wf-h-10 wf-flex wf-items-center wf-justify-center"
          :class="elementClasses(classes('iconContainerClasses'))"
          :style="elementStyles(styles('iconContainerStyles'))"
        >
          <i :style="elementStyles(styles('iconStyles'))" :class="elementClasses(classes('iconClasses'), [content.class, content.icon])"></i>
        </div>
        <div
          class="wf-flex-1"
          :class="elementClasses(classes('contentClasses'))"
          :style="elementStyles(styles('styles'))"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    computed: {
      containerId() {
        return this.$store.getters[`${this.module}/id`](this.element, 'container_id')
      },
    },
  })
</script>
